export const hidenMessageAPI = [
  "user-preferences-general",
  "/auth/login/",
  "/motisha_bhakti_kendra/",
];
